"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoodJujuEffectHandler = exports.GoodJujuEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class GoodJujuEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.GoodJuju;
        this.__typeName = "GoodJuju";
        this.name = "Good Ju Ju";
        this.harmful = false;
    }
}
exports.GoodJujuEffectArgs = GoodJujuEffectArgs;
// TODO: Obsolete
let GoodJujuEffectHandler = class GoodJujuEffectHandler {
    apply(sequence, container, state) {
        state.meta.attributeIncreaseEffectIds = container.applyBuffs({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effects: [enums_1.AttributeType.Power, enums_1.AttributeType.Focus].map((attribute) => ({
                effect: new _1.MaxAttributeIncreaseEffectArgs(attribute, container.getPercentOfBaseAttributeScore(state.targetId, 5, attribute)),
                duration: Duration_1.Duration.Instant,
            }))
        });
    }
    remove(sequence, container, state) {
        for (const effectId of state.meta.attributeIncreaseEffectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
GoodJujuEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.GoodJuju)
], GoodJujuEffectHandler);
exports.GoodJujuEffectHandler = GoodJujuEffectHandler;
